export const bodyPart = {
  head: { label: 'Head', value: 'head' },
  face: { label: 'Face', value: 'face' },
  neck: { label: 'Neck', value: 'neck' },
  chest: { label: 'Chest', value: 'chest' },
  breast: { label: 'Breast', value: 'breast' },
  abdomen: { label: 'Abdomen', value: 'abdomen' },
  upper_extremity: { label: 'Upper Extremity', value: 'upper extremity' },
  full_spine: { label: 'Full Spine', value: 'full spine' },
  cervical_spine: { label: 'Cervical Spine', value: 'cervical spine' },
  lumber_spine: { label: 'Lumbar Spine', value: 'lumbar spine' },
  thoracic_spine: { label: 'Thoracic Spine', value: 'thoracic spine' },
  thoracolumbar_spine: { label: 'Thoracolumbar Spine', value: 'thoracolumbar spine' },
  pelvis: { label: 'Pelvis', value: 'pelvis' },
  lower_extremity: { label: 'Lower Extremity', value: 'lower extremity' },
  whole_body: { label: 'Whole Body', value: 'whole body' }
}
